import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { getAdminAttachmentsUrls, ajaxUploadFile, ajaxRemoveFile } from '../redux/FeedbackRedux';
import Dropzone from '../feedbackdetail/Dropzone';
import Alert from "../Alert";


class AdminAttachmentSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {is_open: false};
    }

    handleOpenChange(event) {
        event.preventDefault();
        this.setState({
            is_open: !this.state.is_open,
        });
    }

    removeAttachment(event){
        if(confirm(__('Please confirm that you wish to delete this attachment'))){
            let id = parseInt(event.target.id);
            this.props.dispatch(ajaxRemoveFile(this.props.feedback.feedback_id, id));
        }
    }
    render () {
        let attachments = [];
        let fa = this.props.feedback.feedback_attachments;
        for(let i = 0; i < fa.length; i++) {
            if (fa[i].type === 'feedback_attachment_ext') {
                continue;
            }

            if(fa[i].mime_type.toLowerCase().includes('image') || fa[i].mime_type.toLowerCase().includes('video')){
                if(fa[i].file.toLowerCase().includes('.mov') || fa[i].file.toLowerCase().includes('.mp4') || fa[i].file.toLowerCase().includes('.m4v') || fa[i].file.toLowerCase().includes('.qt')) {
                    var html = <video key={'video-'+i} className="video-attachment" controls><source key={'key-'+i} src={fa[i].full_url} type="video/mp4"/></video>
                } else {
                    var html = <img key={'img-'+i} id={i} src={fa[i].full_thumb_url} alt="Attachment Image" className="img-attachment cursor-pointer" data-full-image-url={fa[i].full_url} />;
                }
            }
            else{
                let thename = fa[i].file;
                if (fa[i].file.includes("/")) {
                    thename = fa[i].file.split("/")[1];
                }
                let filename = thename;
                if (thename.length > 15) {
                    filename = (thename).slice(thename.length - 15);
                }
                let icon;
                if(fa[i].file.includes(".pdf")){
                    icon = <i className="far fa-file-pdf"></i>;
                }else if(fa[i].file.includes(".doc")){
                    icon = <i className="far fa-file-word"></i>;
                }else if(fa[i].file.includes(".xls")){
                    icon = <i className="far fa-file-excel"></i>;
                }else if(fa[i].file.includes(".xlsx")){
                    icon = <i className="far fa-file-excel"></i>;
                } else {
                    icon = <i className="far fa-file"></i>;
                }
                var html = <a className="file-attachment p-3" key={'key-'+i} href={fa[i].full_url} target="_blank" download><h1>{icon}</h1><h4 className="attachment-file-name">...{filename}</h4></a>
            }

            attachments.push(<div key={'unit-'+i} id={i} className="col-md-3 mb-4 attachment-col">{html}{this.props.current_user && <span className="remove-attachment" data-id={i} id={i} onClick={this.removeAttachment.bind(this)}>✕</span>}{fa[i].uploaded_by && <span className="label">{fa[i].uploaded_by}<br/>{fa[i].created_at_formatted}</span>}</div>);
        }
        return (
            <div className="card-body border-top attachments" id="feedback_detail_attachments">
                <div className='d-flex align-items-center mb-2'>
                    <h4 className="mb-0 mr-1" data-toggle="tooltip" data-title={__('Attachments that can be added to this specific Feedback')}>{ __('Internal Attachments')} </h4>
                    <span>({attachments.length})</span>
                    <div className="ml-2">
                        {!this.state.is_open &&
                            <span className="btn btn-sm btn-primary toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                <i className="far fa-plus"></i>
                            </span>
                        }
                        {this.state.is_open &&
                            <span className="btn btn-sm btn-primary btn-primary-alt toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                <i className="far fa-times"></i>
                            </span>
                        }
                    </div>
                </div>

                    {!this.props.current_user &&
                        <p className="text-muted">None</p>
                    }

                    {(this.props.current_user && this.state.is_open) &&
                        <Dropzone feedback_id={this.props.feedback.feedback_id}></Dropzone>
                    }

                    <br/>
                    <Alert alert={this.props.state.alert.alert} location={'admin-attachments'}/>
                    <div className="row mt-4">
                        {attachments}
                    </div>
            </div>
            );
	}
}


function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(AdminAttachmentSection)
